module.exports = __webpack_public_path__ + "img/tiktok.53fe46b7.png";